import { useNavigate } from 'react-router-dom';
import styles from './DesktopMenu.module.scss';
import { useContext, useState } from 'react';
import { DropdownItem } from 'reactstrap';
import { AppContext } from '../../../globalContext/context';
        

export default function DesktopMenu() {
    const navigate = useNavigate();
    const { menuAll } =   useContext(AppContext);


    const [showSubMenu, setShowSubMenu] = useState({id: '', data: ''});

    const subMenuOnMouseEnterHandler = (subMenuId, subMenuData) => {
        setShowSubMenu((prev) => {
            let selectItem = prev;
            selectItem = {id: subMenuId, data: subMenuData};

          return selectItem
        });
    };
    const subMenuOnMouseLeaveHandler = (subMenuId, subMenuData) => {
        setShowSubMenu((prev) => {
            let selectItem = prev;
            selectItem = {id: subMenuId, data: subMenuData};
            return selectItem;        });
      };

  return (
    <div className={` ${styles.MegaMenuContainer} d-flex`}>
        {/* first level */}
        <div className={`d-flex flex-column ${styles.mainCategories}`}>
            {
                menuAll.map((menu) => {
                    if(!menu.children) {
                        return(
                            <DropdownItem 
                                className={`${styles.menuItem} px-2 text-decoration-none nav-link fw-semibold`} 
                                onClick={() => navigate(`/product-list/${menu.id}/${menu.title.replace(/\s+/g, '-')}`)}
                                onMouseEnter={() => subMenuOnMouseEnterHandler(menu.id, null)}
                                onMouseLeave={() => subMenuOnMouseLeaveHandler(menu.id, null)}
                                key={menu.id}
                                >
                                    <div>
                                        {/* {
                                            menu.icon 
                                                ? (
                                                    <img 
                                                        src={`${!menu.icon ? 'images.png' : `${process.env.REACT_APP_API_URL}${menu.icon}`}`} 
                                                        className={`img-fluid ${styles.icon} me-1`}/>
                                                    ) 
                                                : (
                                                    <i className={'bi bi-chevron-right me-1'}></i>
                                                )
                                        } */}
                                        <span>
                                            {menu.title}
                                        </span>
                                    </div>
                            </DropdownItem> 

                        )
                    }
                    return (
                        <DropdownItem 
                            className={`${styles.menuItem} px-2 text-decoration-none nav-link fw-semibold`} 
                            onClick={() => navigate(`/product-list/${menu.id}/${menu.title.replace(/\s+/g, '-')}`)}
                            onMouseEnter={() => subMenuOnMouseEnterHandler(menu.id, menu)}
                            onMouseLeave={() => subMenuOnMouseLeaveHandler(menu.id, menu)}
                            key={menu.id}
                            >
                                <div>
                                    {/* {
                                        menu.icon 
                                            ? (
                                                <img 
                                                    src={`${!menu.icon ? 'images.png' : `${process.env.REACT_APP_API_URL}${menu.icon}`}`} 
                                                    className={`img-fluid ${styles.icon} me-1`}/>
                                                ) 
                                            : (
                                                <i className={'bi bi-chevron-right me-1'}></i>
                                            )
                                    } */}
                                    <span>
                                        {menu.title}
                                        <i className={'bi bi-chevron-right ms-1'}></i>
                                    </span>
                                </div>
                            </DropdownItem> 
                    )

                })
            }
        {/* content */}
        </div>
        <div className={`d-flex flex-column ${styles.categoriesContentSection}`}>
            <div className={`d-grid ${styles.menuCol}`}>
                {
                showSubMenu.data?.children ?
                    showSubMenu.data.children.map((menu) => {
                        return(
                        <div key={menu.id}>
                            <DropdownItem 
                                className={`${styles.menuItem} text-decoration-none nav-link fw-bold`} 
                                onClick={() => navigate(`/product-list/${menu.id}/${menu.title.replace(/\s+/g, '-')}`)}
                                >
                                    <span className={`${styles.secoundLevel}`}>
                                        {menu.title}
                                    </span>
                            </DropdownItem> 

                            {
                                menu.children && 
                                    menu.children.map((item) => (
                                        <DropdownItem 
                                            className={`${styles.menuItem} ${styles.subMenu} text-decoration-none nav-link ms-2`} 
                                            onClick={() => navigate(`/product-list/${item.id}/${item.title.replace(/\s+/g, '-')}`)}
                                            key={item.id}
                                            >

                                                <span>
                                                    {item.title}
                                                </span>
                                        </DropdownItem> 
                                    ))
                            }
                        </div>
                    )
                    })
                    :
                    <p className="fw-bold p-4">No Categories to Display</p>

                }
            </div>
        </div> 
    </div>
  )
}
